export const NEWS = "/news/admin";
export const TENDER = "/tender/admin";
export const TENDER_UPDATE = (tenderId, tenderUpdateId) =>
  `/tender/admin/${tenderId}/tender-updates/${tenderUpdateId}`;
export const QUERY = "/query/admin";
export const NMC_MANDATE = "/nmc-mandate/";
export const TENDER_CATEGORY = "/tender/category";
export const UPDATE_TENDER_CATEGORY = "/tender/update-category";
export const RESET_PASSWORD = "/user/reset-password";
export const FORGOT_PASSWORD = "/user/forgot-password";
export const DEPARTMENT = "/department";
export const DEPARTMENT_CATEGORY = "/department/category";
export const FACULTY = `/faculty`;
export const GALLERY = `/gallery`;
export const SRC = `/research/src/admin`;
export const IEC = `/research/iec/admin`;
export const ACADEMICS_ADMINISTRATION = `/academics/administration/admin`;
export const ACADEMICS_ADMINISTRATION_BY_ID = (id) => {
  return `${ACADEMICS_ADMINISTRATION}/${id}`;
};

export const EXIT_EXAMINATION_CALENDER = `/academics/calendar/admin`;
export const EXIT_EXAMINATION_CALENDER_BY_ID = (id) => {
  return `${EXIT_EXAMINATION_CALENDER}/${id}`;
};
export const EXIT_EXAMINATION_EVENT = `/academics/event/admin`;
export const ANNOUNCEMENT = `/announcement/admin`;
export const USER_ADMIN = `/user/department-admin`;
export const RESEARCH = `/research`;
export const SCIENTIFIC_RESEARCH_COMMITTEE = `/research/scientific_research_committee`;
export const RESEARCH_HEADER = `/research/content`;
export const RESEARCH_DETAIL = (id) => `/research/${id}`;
export const ADD_DOCUMENT = `/research/documents`;
export const UPDATE_DOCUMENT = (id) => `/research/documents/${id}`;
export const COMMITTEE_MEMBER = `/research/committee-members`;
export const COMMITTEE_MEMBER_BY_ID = (id) =>
  `/research/committee-members/${id}`;
export const GET_FACULTY_BY_ID = (id) => `/department/faculty/${id}`;
export const NOTICE_IN_RESEARCH = `/research/news`;
export const ADMIN_ADD_UPDATE_TENDER = (id) =>
  `/tender/admin/${id}/tender-updates`;

export const ADMIN_ADD_NEWS_UPDATE = (id) => `/news/admin/${id}/news-update`;
export const EDIT_NEWS_UPDATE = (newId, newsUpdateId) =>
  `/news/admin/${newId}/news-update/${newsUpdateId}`;
